// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"223":"commons","279":"component---src-pages-index-jsx","813":"component---src-pages-busqueda-jsx"}[chunkId] + "-" + {"223":"dcf890e75e7721c86e7e","279":"ca2ae002ef614d9e529d","813":"13bae161b56c6e876416"}[chunkId] + ".js";
};